import { Spinner } from '@/components/ui/spinner';

/**
 * 整頁置中的 spinner。
 *
 * 兩個地方共用同一個，是刻意的：空殼（`app.html`，E6-09）在 JS 到之前畫的是它，
 * JS 到了之後 `RequireAuth` 還在還原 session 時畫的也是它——冷啟動後台頁的時候，
 * 畫面從頭到尾是同一個 spinner，不會「spinner → 跳一下 → 另一個 spinner」。
 *
 * 這個檔不能 import 任何碰得到 `window`／`localStorage` 的東西：預渲染在沒有瀏覽器的
 * 環境跑（見 `entry-server.test.tsx`）。
 */
export function FullPageSpinner() {
  return (
    <div className="flex h-screen items-center justify-center">
      <Spinner className="size-6 text-muted-foreground" />
    </div>
  );
}
